import React from 'react';
import { Card, Row, Col, FormControl } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import PropTypes from 'prop-types';

const DetailsFournisseur = ({ document, setDocument }) => {
  return (
    <Card>
      <Card.Body>
        <Card.Title style={{ borderTop: '5px solid blue' }} className="pt-2">
          Details du document
        </Card.Title>
        <Card.Body>
          <Row
            className="d-flex align-items-center pb-2"
            style={{ borderBottom: '1px solid #e0e0e0' }}
          >
            <Col>
              <h6>Référence :</h6>
            </Col>
            <Col className="text-end">
              <FormControl placeholder="ref" aria-label="rérérence" />
            </Col>
          </Row>
          <Row
            className="mt-2 d-flex align-items-center pb-2"
            style={{ borderBottom: '1px solid #e0e0e0' }}
          >
            <Col>
              <h6>Date :</h6>
            </Col>
            <Col className="text-end">
              <DatePicker
                dateFormat={'dd/MM/yyyy'}
                popperPlacement="bottom-start"
                selected={document.dateDocument || new Date()}
                onChange={date =>
                  setDocument({ ...document, dateDocument: date })
                }
                formatWeekDay={day => day.slice(0, 3)}
                className="form-control"
                placeholderText="Select Date"
              />
            </Col>
          </Row>
          <Row
            className="mt-2 d-flex align-items-center pb-2"
            style={{ borderBottom: '1px solid #e0e0e0' }}
          >
            <Col>
              <h6>Date de livraison :</h6>
            </Col>
            <Col className="text-end">
              <DatePicker
                dateFormat={'dd/MM/yyyy'}
                popperPlacement="bottom-start"
                selected={document.dateLivraison || new Date()}
                onChange={date =>
                  setDocument({ ...document, dateLivraison: date })
                }
                formatWeekDay={day => day.slice(0, 3)}
                className="form-control"
                placeholderText="Select Date"
              />
            </Col>
          </Row>
        </Card.Body>
      </Card.Body>
    </Card>
  );
};

DetailsFournisseur.propTypes = {
  document: PropTypes.object.isRequired,
  setDocument: PropTypes.func.isRequired
};

export default DetailsFournisseur;
